import React from 'react';
import { convertToLocalTimeString, convertToLocalDateString } from '../../utils/maintenanceUtils';
import { Alert } from '@cof/gravity-react';
import { downtimeBannerNotification } from '../../strings';
import './ScheduledMaintenanceBanner.scss';
import { useMaintenanceMode } from '../hooks/useMaintenanceMode';

export const ScheduledMaintenanceBanner = ({ activeLanguage }) => {
  const maintenanceStatus = useMaintenanceMode();

  if (!maintenanceStatus.isScheduledMaintenance) {
    return null;
  }
  const message = downtimeBannerNotification[activeLanguage].Message
    .replace('[DATE]', convertToLocalDateString(activeLanguage,maintenanceStatus.maintenanceWindow.start))
    .replace('[START TIME]',  convertToLocalTimeString(activeLanguage,maintenanceStatus.maintenanceWindow.start))
    .replace('[END TIME]',  convertToLocalTimeString(activeLanguage,maintenanceStatus.maintenanceWindow.end));
  return (
    <div className="maintenance-banner" data-testid="downtime-banner">
      <Alert
        type="informational"
        message={message}
      />
    </div>
  );
};

export default ScheduledMaintenanceBanner;
